module.exports = __webpack_public_path__ + "static/images/goods-group-gift-img.5cbe809.png";